import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ConfirmationDialogAction, ConfirmationDialogResult } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'herkunftsnachweis-dialog',
  templateUrl: './herkunftsnachweis-dialog.component.html'
})
export class HerkunftsnachweisDialogComponent extends DialogContentBase {
  public herkunftsnachweisForm: UntypedFormGroup;

  public get isSaveButtonDisabled(): boolean {
    return this.herkunftsnachweisForm.invalid;
  }

  constructor(dialog: DialogRef) { 
    super(dialog);
    this.initFormGroup();
  }

  public onCancelClick() {
    let result: HerkunftsnachweisDialogResult = new HerkunftsnachweisDialogResult();

    result.action = ConfirmationDialogAction.Cancel;

    this.dialog.close(result);
  }

  public onSaveClick() {
    let result: HerkunftsnachweisDialogResult = new HerkunftsnachweisDialogResult();

    result.action = ConfirmationDialogAction.Confirm;
    result.herkunftsnachweis = this.herkunftsnachweisForm.controls["herkunftsnachweis"].value;

    this.dialog.close(result);
  }


  protected initFormGroup(): void {
    this.herkunftsnachweisForm = new UntypedFormGroup({
      herkunftsnachweis: new UntypedFormControl(null, [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]),
    });
  }
}

export class HerkunftsnachweisDialogResult extends ConfirmationDialogResult {
  public herkunftsnachweis: string;
}